<div class="modal fade" id="kt_modal_car_listing" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-header p-3 d-flex justify-content-between bg-secondary">
				<div class="d-flex align-items-center">
					<h2 class="fw-bold m-0 me-3">Choose From Stock</h2>
					<span class="badge badge-light-primary" *ngIf="selectedCars.length > 0">
						{{ selectedCars.length }} Selected
					</span>
				</div>
				<div class="d-flex align-items-center gap-2">
					<button
						type="button"
						class="btn btn-sm btn-success"
						(click)="addSelectedCars()"
						[disabled]="selectedCars.length === 0">
						<i class="ki-duotone ki-plus fs-2">
							<span class="path1"></span>
							<span class="path2"></span>
							<span class="path3"></span>
						</i>
						Add Selected ({{ selectedCars.length }})
					</button>
					<div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
						<i class="ki-duotone ki-cross fs-1">
							<span class="path1"></span>
							<span class="path2"></span>
						</i>
					</div>
				</div>
			</div>
			<div class="modal-body p-5">
				<div class="d-flex flex-column">
					<!-- Search and Filter Section -->
					<div class="row mb-5">
						<div class="col-md-4">
							<div class="form-floating">
								<input
									type="text"
									class="form-control"
									id="searchInput"
									placeholder="Search cars..."
									[(ngModel)]="searchTerm"
									(input)="onSearchInput($event)">
								<label for="searchInput">Search cars...</label>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-floating">
								<select
									class="form-select"
									id="makeFilter"
									[(ngModel)]="selectedMake"
									(change)="onMakeChange($event)">
									<option value="">All Makes</option>
									<option *ngFor="let make of makesList" [value]="make.value">{{ make.label }}</option>
								</select>
								<label for="makeFilter">Filter by Make</label>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-floating">
								<select
									class="form-select"
									id="modelFilter"
									[(ngModel)]="selectedModel"
									(change)="onModelChange($event)"
									[disabled]="!selectedMake">
									<option value="">All Models</option>
									<option *ngFor="let model of modelsList" [value]="model.value">{{ model.label }}</option>
								</select>
								<label for="modelFilter">Filter by Model</label>
							</div>
						</div>
						<div class="col-md-2">
							<button
								type="button"
								class="btn btn-primary h-100 w-100"
								(click)="onSearch()"
								[disabled]="isLoading">
								<span *ngIf="!isLoading">
									<i class="ki-duotone ki-magnifier fs-2">
										<span class="path1"></span>
										<span class="path2"></span>
									</i>
									Search
								</span>
								<span *ngIf="isLoading">
									<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									Searching...
								</span>
							</button>
						</div>
					</div>

					<!-- Car Listing Table -->
					<div class="table-responsive">
						<table class="table table-striped table-hover align-middle">
							<thead class="table-dark">
								<tr>
									<th style="width: 50px;">
										<div class="form-check form-check-sm form-check-custom form-check-solid">
											<input
												class="form-check-input"
												type="checkbox"
												[checked]="selectAll"
												(change)="toggleSelectAll($event)"
												[disabled]="isLoading || cars.length === 0">
											<label class="form-check-label"></label>
										</div>
									</th>
									<th>Image</th>
									<th>Make & Model</th>
									<th>Year</th>
									<th>Chassis No.</th>
									<th>Mileage</th>
									<th>Fuel</th>
									<th>Color</th>
									<th>Price</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<!-- Loading state -->
								<tr *ngIf="isLoading">
									<td colspan="10" class="text-center py-5">
										<div class="d-flex justify-content-center align-items-center">
											<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
											Loading cars...
										</div>
									</td>
								</tr>

								<!-- No data state -->
								<tr *ngIf="!isLoading && cars.length === 0">
									<td colspan="10" class="text-center py-5">
										<div class="text-muted">
											<i class="ki-duotone ki-information fs-2x mb-3">
												<span class="path1"></span>
												<span class="path2"></span>
												<span class="path3"></span>
											</i>
											<div>No cars found matching your criteria</div>
										</div>
									</td>
								</tr>

								<!-- Car data rows -->
								<tr *ngFor="let car of cars" [class.table-active]="isCarSelected(car)">
									<td>
										<div class="form-check form-check-sm form-check-custom form-check-solid">
											<input
												class="form-check-input"
												type="checkbox"
												[checked]="isCarSelected(car)"
												(change)="toggleCarSelection(car, $event)"
												[disabled]="$any(car).is_sold">
											<label class="form-check-label"></label>
										</div>
									</td>
									<td>
										<div class="symbol symbol-50px">
											<img
												[src]="getMainImage(car)"
												[alt]="car.name + ' Image'"
												class="rounded"
												(error)="$any($event.target).src='assets/media/stock/600x400/img-1.jpg'">
										</div>
									</td>
									<td>
										<div class="d-flex flex-column">
											<span class="fw-bold">{{ car.name }}</span>
											<small class="text-muted">{{ $any(car).company_name }}</small>
											<small class="text-muted">{{ $any(car).car_no }}</small>
										</div>
									</td>
									<td>{{ $any(car).year }}</td>
									<td>
										<span class="text-nowrap">{{ $any(car).vin_no }}</span>
									</td>
									<td>{{ formatMileage($any(car).mileage || 0) }}</td>
									<td>{{ $any(car).fuel_type }}</td>
									<td>{{ $any(car).color }}</td>
									<td>
										<span class="fw-bold text-success">{{ formatPrice($any(car).price || 0) }}</span>
									</td>
									<td>
										<button
											type="button"
											class="btn btn-sm"
											[class.btn-success]="isCarSelected(car)"
											[class.btn-outline-primary]="!isCarSelected(car) && !$any(car).is_sold"
											[class.btn-outline-secondary]="$any(car).is_sold"
											(click)="selectCar(car)"
											[disabled]="$any(car).is_sold">
											<span *ngIf="$any(car).is_sold" class="text-muted">Sold</span>
											<span *ngIf="!$any(car).is_sold && !isCarSelected(car)">Select</span>
											<span *ngIf="!$any(car).is_sold && isCarSelected(car)">
												<i class="ki-duotone ki-check fs-2">
													<span class="path1"></span>
													<span class="path2"></span>
												</i>
												Selected
											</span>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<!-- Pagination -->
					<div class="d-flex justify-content-between align-items-center mt-5" *ngIf="!isLoading && cars.length > 0">
						<div class="text-muted">
							Showing {{ paginationInfo.currentPage === 1 ? 1 : ((paginationInfo.currentPage - 1) * paginationInfo.perPage) + 1 }}
							to {{ Math.min(paginationInfo.currentPage * paginationInfo.perPage, paginationInfo.total) }}
							of {{ paginationInfo.total }} entries
						</div>
						<app-pagination
							[paginationInfo]="paginationInfo"
							[loading]="isLoading"
							(pageChange)="onPageChange($event)">
						</app-pagination>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
			</div>
		</div>
	</div>
</div>
